import PageTitle from "components/PageTitle/PageTitle";
import PageFrame from "components/Panels/PageFrame";
import TMListView from "./TMListView";

const TMListService = () => {
  return (
    <PageFrame
      children={
        <div>
          <PageTitle titleText="TM 리스트" />
          <TMListView />
        </div>
      }
    />
  );
};
export default TMListService;
